import { call, put, takeLatest } from "redux-saga/effects";
import { GET_ReportAnalytics } from "../services/Report";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_ReportAnalyticsEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_ReportAnalytics, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_ReportAnalytics", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* ReportSaga() {
  yield takeLatest("GET_ReportAnalytics", GET_ReportAnalyticsEffect);
}
